import React, { useEffect, useRef, useState } from "react";
import { Card, PageTitle } from "../../../styles";
import Table from "../../../components/Table/Table";
import { EmptyState } from "../../../components/EmptyState/EmptyState";
import LoadMoreButton from "../../../components/LoadMoreButton";
import { ReactComponent as EmptyStateImg } from "../../../assets/empty-followup.svg";
import { ReactComponent as ExpandMoreIcon } from "../../../assets/expandMore.svg";
import { ReactComponent as SearchIconCustom } from "../../../assets/searchIconGrey.svg";
import Filter from "../Messages/Filter";
import {
  createCohortExport,
  getReportCohortDataWithId,
  getPatientsInCohort,
  getReportCohortWithId,
  showAlert,
  updateCohortReports,
  getCohortChart,
  RESET_REPORT_COHORT_DATA_WITH_ID,
} from "../../../actions/radminUploads";
import styled from "styled-components";
import {
  BarChart,
  Cell,
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  Bar,
  LineChart,
  Line,
  PieChart,
  Pie,
  Tooltip,
  Legend,
  Rectangle,
  Sector,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import { ReactComponent as FollowupRecommendedIcon } from "../../../assets/follow-up-recommended-icon.svg";
import { RecommendationTooltip } from "./../SearchReportText/RecommendationTooltip";
import ViewReportModal from "../Messages/ViewReportModal";
import { HeaderContainer } from "../Cohorts/ViewPatients";
import SearchField from "../SharedComponents/SearchField";
import { Button, makeStyles } from "@material-ui/core";
import Box from "../../../components/_styles/Box";
import BackButton from "../../../components/BackButton";
import DoubleDataCell from "../PatientList/LastScanCell";
import ExportCohortModal from "../Cohorts/ExportCohortModal";
import { parseQuery } from "../RecommendationCohorts/util";
import DescriptionChipGroups from "../RecommendationCohorts/DescriptionChipGroups";
import moment from "moment";
import { computedStatusColors, formatMonthYear } from "../../../utils/utils";
import { Spinner } from "react-bootstrap";
import { Tooltip as MaterialTooltip, withStyles } from "@material-ui/core";

const StyledTooltip = (props) => {
  const { className, ...other } = props;

  return (
    <MaterialTooltip
      {...other}
      interactive={true}
      enterDelay={0}
      leaveDelay={200} 
      PopperProps={{
        className: className,
        style: {
          backgroundColor: "#AEE3F8",
          borderRadius: "4px",
          zIndex: 3,
        },
      }}
    />
  );
};

const StyledTooltipWrapper = withStyles(() => ({
  tooltip: {
    backgroundColor: "transparent",
    color: "black!important",
    fontSize: "14px!important",
    fontWeight: 400 + "!important",
    width: "420px",
    padding: "10px",
    textAlign: "center",
    margin: "0px",
    position: "relative",
  },
}))(StyledTooltip);

const StyledEmptyContainer = styled.div`
  display: flex;
  height: 300px;
  justify-content: center;
  align-items: center;
`;
const StyledLink = styled(Link)`
  color: #00aeef;
  font-size: 14px;
  font-weight: 400;
  text-decoration: underline;
`;

const HeadingWrapper = styled.div`
  display: flex;
  padding-left: 26px;
  gap: 5px;
`;

const CohortDescriptionContainer = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => (props.isClicked ? "" : "3")};
  font-size: 13px;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 21px;
  margin-left: 25px;
  font-weight: 100px;
`;

const FilterContainer = styled.div`
display: flex;
width: 253px;
align-items: center;
flex-direction: column;
gap: 20px;
& > div {
  padding: 0px;
  width: 100%;
  & > div {
    width: 100%;
    height: 38px;
    & > span > div > .select__control {
      height: 38px;
    }
    & > span > div {
      height: 38px;
    }
  }
}
`;
const options = [
  { value: "Last 7 days", label: "Last 7 days" },
  { value: "Last 30 days", label: "Last 30 days" },
  { value: "Last 3 months", label: "Last 3 months" },
  { value: "Last 12 months", label: "Last 12 months" },
  { value: "Custom date range", label: "Custom date range" },
];


const Description = styled.span`
  font-family: Roboto Condensed;
  font-style: normal;
  font-size: 24px;
  font-weight: 600;
  text-align: initial;
  color: #0C2945;
  margin: 0px;
  line-height:normal;
  white-space:nowrap;
`;

const DescriptionValue = styled.div`
  font-family: Roboto Condensed;
  font-style: normal;
  font-size: 14px;
  text-align: initial;
  color: #000000;
  margin: 0px;
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
`;
const CohortTitle = styled.div`
  font-family: Roboto Condensed;
  font-style: normal;
  font-size: 23px;
  font-weight: 500;
  text-align: initial;
  color: #000000;
  margin: 0px;
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
`;
const SearchFieldContainer = styled.div`
  display: flex;
  flex: auto;
  justify-content: right;
  height: 38px;
  margin-right: 17px;
`;

const HeadingLabel = styled.h1`
  font-family: Roboto Condensed;
  font-size: 36px;
  font-weight: 700;
  color: #0c2945;
  margin: unset;
`;

const RecalculateContainer = styled.div`
  margin-left: 15px;
  display: flex;
  flex-direction: column;
`;
const RecalculateCohortLabel = styled.span`
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.2px;
  color: ${({ disabled }) => (disabled ? "#9E9E9E" : "#00aeef")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  text-decoration: ${({ disabled }) => (disabled ? "none" : "underline")};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
`;
const LoadingLabel = styled.span`
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.2px;
  color: #00aeef;
`;
const LastUpdatedLabel = styled.span`
  font-size: 14px;
  font-family: Roboto Condensed;
`;

const ReportsCount = styled.div`
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  color: #0c2945;
  justify-content: center;
`;

const SelectDropdownTitle = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #6d6e6e;
  text-align: left;
  text-transform: uppercase;
`;

const useStyles = makeStyles({
  label: {
    padding: "5px 0px",
    fontSize: "12px",
    fontWeight: "bold",
  },
  campaignButton: {
    backgroundColor: "#00AEEF",
    textTransform: "none",
    width: "9rem",
    height: "38px",
    color: "#FFFFFF",
    border: "2px solid #00AEEF",
    "&:hover": {
      backgroundColor: "transparent",
      color: "#00AEEF",
    },
  },
      editCohort: {
        color: "#00AEEF",
        textTransform: 'none',
        width: '8rem',
        background: "transparent",
        border: "2px solid #00AEEF",
        "&:hover": {
          backgroundColor: "transparent",
        },
        padding: '1px 8px',
        marginRight: '4%'
    },
});

const ReportComponent = ({
  reportText,
  row,
  rows,
  idx,
  hasMoreRecords,
  onLoadMore,
  isLoading,
}) => {
  const [showFullReport, setShowFullReport] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState({
    report_text: row?.report_text,
    accession_number: row?.accession_number,
    initial_exam_date: row?.initial_exam_date,
    modality: row?.reco_modality,
    patient: { mrn: row?.patient_mrn, id: row?.patient_id },
    report_id: row?.id,
  });

  const [index, setIndex] = useState(idx);

  const toggleReportVisibility = () => {
    window.analytics.track(
      `Search-Report-Visibility-${!showFullReport ? "Expanded" : "Collapsed"
      }-Click`
    );
    setShowFullReport(!showFullReport);
    setShowModal(true);
  };

  useEffect(() => {
    setData({
      report_text: rows[index]?.report_text,
      accession_number: rows[index]?.accession_number,
      initial_exam_date: rows[index]?.initial_exam_date,
      modality: rows[index]?.modality,
      patient: { mrn: rows[index]?.patient?.mrn, id: rows[index]?.patient?.id },
      report_id: rows[index]?.id,
      location_address: rows[index]?.location_address
    });
  }, [index, rows]);

  return (
    <span>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "21px",
        }}
      >
        <span style={{ maxWidth: "450px" }}>
          {reportText.length >= 100
            ? reportText.slice(0, 100) + "..."
            : reportText}
        </span>
        <ExpandMoreIcon
          style={{ width: 18, height: 18, cursor: "pointer" }}
          onClick={toggleReportVisibility}
        />
        {showModal && (
          <ViewReportModal
            data={data}
            showModal={showModal}
            closeModal={() => {
              setShowModal(false);
              setIndex(idx);
              setData({
                report_text: row?.report_text,
                accession_number: row?.accession_number,
                initial_exam_date: row?.initial_exam_date,
                modality: row?.reco_modality,
                patient: { mrn: row?.patient?.mrn, id: row?.patient?.id },
                report_id: row?.id,
              });
            }}
            handlePrev={() => {
              if (index > 0) {
                setIndex((prev) => prev - 1);
              }
            }}
            handleNext={() => {
              if (index === rows.length - 1 && hasMoreRecords) {
                onLoadMore();
                setIndex((prev) => prev + 1);
              } else if (index < rows.length - 1) {
                setIndex((prev) => prev + 1);
              }
            }}
            isPaginated={true}
            disabledPrev={index === 0}
            disabledNext={index === rows.length - 1 && !hasMoreRecords}
            isLoading={isLoading}
            showCreateRecommendations={false}
          />
        )}
      </div>
    </span>
  );
};

const ViewReports = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams();
  const cohortReportListWithId = useSelector(
    (state) => state.radAdmin.cohotReportwithId
  );
  const cohortWithId = useSelector(
    (state) => state.radAdmin.reportCohortDataWithId.data
  );

     let params = new URLSearchParams(history.location.search);
    let timeRange = params.get("timeframe");

    let timeframe =
      timeRange ? timeRange || "Last 30 days" : "Last 30 days";

    let timeframeItem = options.find((itm) => itm.value === timeframe);
    if (timeframe && !timeframeItem) {
    timeframeItem = {
      value: "Custom date range",
      label: "Custom date range",
    };
  }

    var date = new Date();
     let requiredDate;
      let lastMoment;
      let startingDate;
      let endingDate;
      if (timeframe) {
        if (
          timeframe !== "Last 7 days" &&
          timeframe !== "Last 30 days" &&
          timeframe !== "Last 3 months" &&
          timeframe !== "Last 12 months"
        ) {
          const timeframeData = timeframe.split("-");
          const formattedDateStringStart = timeframeData[0];
          const formattedDateStringEnd = timeframeData[1];
          const dateObjStart = moment(formattedDateStringStart, "MM/DD/YYYY");
          const dateObjEnd = moment(formattedDateStringEnd, "MM/DD/YYYY");

          const day = dateObjStart.format("DD");
          const month = dateObjStart.format("MMM");
          const year = dateObjStart.format("YYYY");

          startingDate = `${dateObjStart.format(
            "ddd"
          )} ${month} ${day} ${year} 00:00:00 GMT+0530 (India Standard Time)`;

          const day2 = dateObjEnd.format("DD");
          const month2 = dateObjEnd.format("MMM");
          const year2 = dateObjEnd.format("YYYY");


          endingDate = `${dateObjEnd.format(
            "ddd"
          )} ${month2} ${day2} ${year2} 00:00:00 GMT+0530 (India Standard Time)`;
        } else {
          if (timeframe === "Last 7 days") {
            lastMoment = new Date(date.getTime() - 7 * 24 * 60 * 60 * 1000);
          } else if (timeframe === "Last 30 days") {
            lastMoment = new Date(date.getTime() - 30 * 24 * 60 * 60 * 1000);
          } else if (timeframe === "Last 3 months") {
            lastMoment = new Date(date.getTime() - 90 * 24 * 60 * 60 * 1000);
          }

          if (timeframe === "Last 12 months") {
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear() - 1;
            requiredDate = `${month}/${day}/${year}`;
          } else {
            let day = lastMoment?.getDate();
            let month = lastMoment?.getMonth() + 1;
            let year = lastMoment?.getFullYear();
            requiredDate = `${month}/${day}/${year}`;
          }
        }
      }
     const [selectedDate, setSelectedDate] = useState(
      requiredDate || ""
    );
    const [filterValue, setFilterValue] = useState(timeframeItem || null);
  const [startDate, setStartDate] = useState(startingDate || "");
    const [endDate, setEndDate] = useState(endingDate || "");


  const [page, setPage] = useState(1);
  const [titleForSearch, setTitleForSearch] = useState("");
  const [selectedCohortId, setSelectedCohortId] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [showCohortModal, setShowCohortModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState();
  const [computedStatusData, setComputedStatusData] = useState([]);
  const [chartLoading, setChartLoading] = useState(false);

  const [lastUpdated, setLastUpdated] = useState(() =>
    moment(cohortWithId?.last_updated).fromNow()
  );

  const permission = useSelector((state) => state.auth.user.permission_level);
  const rolePermissions = useSelector((state) => state.auth.user.permissions);
  const updatePermission = rolePermissions
    ?.find((itm) => itm.name === "Cohorts")
    ?.permissions.find(
      (itm) => itm.codename === "change_cohorts"
    )?.is_authorized;
  const exportPermission = rolePermissions
    ?.find((itm) => itm.name === "Export")
    ?.permissions.find((itm) => itm.codename === "add_export")?.is_authorized;


  useEffect(() => {
    if (cohortWithId?.active) {
    if (
    (cohortWithId?.status === "in_progress" || cohortWithId?.status === "created" ) && !loading
    ) {
      setLoading(true);
      setStatus("in_progress");
      startPolling();
    }}
  }, [cohortWithId?.id, cohortWithId?.status]);

  useEffect(() => {
    setChartLoading(true);
    if (cohortWithId?.status === "completed" && cohortWithId?.id && (selectedDate || endDate) && cohortWithId?.computed_status_criteria?.computed_status_filter?.length > 0) {
        dispatch(getCohortChart(cohortWithId?.id, selectedDate || "", startDate && endDate ? {startDate, endingDate}: {} )).then((response) => {
          if(response) {
            setComputedStatusData(response || []);
          }
          setChartLoading(false);
        })
      } else {
        setChartLoading(false);
      }
  }, [cohortWithId?.id, startDate, endDate, selectedDate, cohortWithId?.computed_status_criteria?.computed_status_filter]);



  const handleRecalculateReports = async () => {
    if(cohortWithId?.active){
    if (!loading) {
      if ((permission && updatePermission) || !permission) {
        setLoading(true);
        try {
          const response = await dispatch(updateCohortReports(id));
          if (response?.data?.status === "in_progress") {
            setStatus("in_progress");
            startPolling();
          } else if (response?.data?.status === "errored") {
            setStatus("errored");
            setLoading(false);
          }
        } catch (error) {
          setStatus("errored");
          setLoading(false);
        }
      } else {
        dispatch(
          showAlert(
            "danger",
            "Error",
            `You don't have permission to update cohort`
          )
        );
      }
    }
  }
  };
  const intervalRef = useRef(null);

  const startPolling = () => {
    intervalRef.current = setInterval(checkStatus, 10000);
  };

  const stopPolling = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  };

  function removeUnderscores(text) {
    return text.replace(/_/g, ' ');
  };

  const checkStatus = async () => {
    try {
      const query = new URLSearchParams(history.location.search);
      let title = query.get("accession_number");

      const response = await dispatch(getReportCohortDataWithId(id));
      if (response && response.payload?.status === "completed") {
        stopPolling();
        setStatus("completed");
        setLoading(false);
        setPage(1);
        dispatch(
          getReportCohortWithId(
            1,
            props.location.state.data?.id,
            title ? title : titleForSearch
          )
        );
      } else if (response && response.payload?.status === "errored") {
        stopPolling();
        setStatus("errored");
        setLoading(false);
      }
    } catch (error) {
      stopPolling();
      setStatus("errored");
      setLoading(false);
    }
  };
  useEffect(() => {
    return () => {
      stopPolling();
    };
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setLastUpdated(moment(cohortWithId?.last_updated).fromNow());
    }, 1000);

    return () => clearInterval(intervalId);
  }, [cohortWithId?.last_updated]);

   useEffect(() => {
      if (filterValue) {
        var date = new Date();
        let requiredDate;
        let lastMoment;
        if (filterValue.value === "Custom date range") return;
        setStartDate("");
        setEndDate("");

        history.push({
          pathname: `/auth/radAdmin/followUp/reports/cohorts/details/${id}`,
          state: props.location.state,
          search: `?timeframe=${filterValue.value}`,
        });

        if (filterValue.value === "Last 7 days") {
          lastMoment = new Date(date.getTime() - 7 * 24 * 60 * 60 * 1000);
        } else if (filterValue.value === "Last 30 days") {
          lastMoment = new Date(date.getTime() - 30 * 24 * 60 * 60 * 1000);
        } else if (filterValue.value === "Last 3 months") {
          lastMoment = new Date(date.getTime() - 90 * 24 * 60 * 60 * 1000);
        }
        if (filterValue.value === "Last 12 months") {
          let day = date.getDate();
          let month = date.getMonth() + 1;
          let year = date.getFullYear() - 1;
          requiredDate = `${month}/${day}/${year}`;
          setSelectedDate(requiredDate);
          return;
        }
        let day = lastMoment.getDate();
        let month = lastMoment.getMonth() + 1;
        let year = lastMoment.getFullYear();
        requiredDate = `${month}/${day}/${year}`;
        setSelectedDate(requiredDate);
      }
    }, [filterValue, history]);

     useEffect(() => {
     if (startDate && endDate) {
        let startingDate, endingDate;
        if (startDate) {
          startingDate = moment(startDate).format("MM/DD/YYYY");
        }
        if (endDate) {
          endingDate = moment(endDate).format("MM/DD/YYYY");
        }
         history.push({
          pathname: `/auth/radAdmin/followUp/reports/cohorts/details/${id}`,
          state: props.location.state,
          search: `?timeframe=${startingDate}-${endingDate}`,
        });
      }

    }, [startDate, endDate, history]);

  const onLoadMore = () => {
    if (props.location.state?.data) {
      const { data } = props.location.state;
      dispatch(getReportCohortWithId(page + 1, data?.id, titleForSearch));
    }
    setPage(page + 1);
  };

  const SearchReportsColumns = [
    { key: "accession_number", name: "Accession Number", align: "left" },
    {
      key: "patient_mrn",
      name: "Patient MRN",
      displayCell: (patient, row) => (
        <StyledLink
          to={`/auth/radAdmin/followUpList/patients/patientDetails/${row?.patient?.id}`}
          target="_blank"
          onClick={(e) => {
            e.stopPropagation();
            window.analytics.track(`Reports-Search-List-Patient-MRN-Click`);
          }}
        >
          {row?.patient?.mrn ?? "-"}
        </StyledLink>
      ),
      align: "left",
    },
    { key: "initial_exam_date", name: "Exam Date", align: "left" },
    {
      key: "follow_up_recommended",
      name: "Follow-up Recommended",
      align: "left",
      displayCell: (cellValue, rowData) =>
        cellValue ? (
          <RecommendationTooltip
            recommendations={rowData?.recommendations ?? []}
          >
            <FollowupRecommendedIcon style={{ cursor: "pointer" }} />
          </RecommendationTooltip>
        ) : (
          "-"
        ),
    },
    { key: "computed_status", name: "Computed Status", align: "left", displayCell: (cellValue) => <div>{cellValue ? removeUnderscores(cellValue) : '-'}</div> },
    { key: "guideline_type", name: "Gudeline Type", align: "left", displayCell: (cellValue) => <div>{cellValue ?? '-'}</div> },
    { key: "special_guideline_type", name: "Special Gudeline Type", align: "left", displayCell: (cellValue) => <div>{cellValue ?? '-'}</div> },
    { key: "guideline_score", name: "Gudeline Score", align: "left", displayCell: (cellValue) => <div>{cellValue?? '-'}</div> },
    { key: "special_guideline_score", name: "Special Gudeline Score", align: "left", displayCell: (cellValue) => <div>{cellValue ?? '-'}</div> },
    {
      key: "report_text",
      name: "Report Text",
      displayCell: (report, row, idx, rows) => {
        return (
          <ReportComponent
            reportText={report}
            row={row}
            rows={rows}
            idx={idx}
            hasMoreRecords={
              cohortReportListWithId?.totalItems !==
              cohortReportListWithId?.data?.length
            }
            onLoadMore={onLoadMore}
            isLoading={cohortReportListWithId?.isLoading}
          />
        );
      },
      align: "left",
    },
  ];

  const checkboxHandler = (data) => {
    if (selectedIds.includes(data.id)) {
      const filteredItems = selectedIds.filter((item) => {
        return item !== data.id;
      });
      setSelectedIds([...filteredItems]);
    }
    if (!selectedIds.includes(data.id)) {
      selectedIds.push(data.id);
      setSelectedIds([...selectedIds]);
    }
  };

  const { parents, operators } = parseQuery(selectedCohortId?.description);


  const createCohortHandler = () => {
    if ((permission && exportPermission) || !permission) {
      dispatch(createCohortExport(id, selectedIds, true)).then((res) => {
        if (res) setShowCohortModal(true);
      });
    } else {
      dispatch(
        showAlert(
          "danger",
          "Error",
          `You don't have permission to export cohort`
        )
      );
    }
  };

  useEffect(() => {
    const query = new URLSearchParams(history.location.search);
    let title = query.get("accession_number");

    // Initialize search input with URL parameter
    if (title) {
      setTitleForSearch(title);
    }

    if (props.location.state?.data) {
      const { data } = props.location.state;
      setSelectedCohortId(data);
      if (data?.id) {
        dispatch(
          getReportCohortWithId(page, data?.id, title ? title : titleForSearch)
        );
        dispatch(getReportCohortDataWithId(data?.id));
      }
    }
  }, []);

 const dynamicStatuses = ['not_compliant', 'completed', 'scheduled', 'not_completed', 'ordered'];

  useEffect(() => {
    return () => {
      dispatch({ type: RESET_REPORT_COHORT_DATA_WITH_ID });
    };
  },[]);
  
  return (
    <Box p={30}>
    <div style={{display:'flex', justifyContent:'space-between'}}>
      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
        <BackButton
          fallbackPath="/auth/radAdmin/followUp/cohorts?tab=reports"
          style={{ marginBottom: 0 }}
        />
        <HeadingLabel>Reports:</HeadingLabel>
        <ReportsCount>{cohortWithId?.total_reports || 0}</ReportsCount>
        <RecalculateContainer>
          {lastUpdated && !loading && (
            <LastUpdatedLabel> Last Updated : {lastUpdated}</LastUpdatedLabel>
          )}
          {!loading && (
             <StyledTooltipWrapper
               title={
                 !cohortWithId?.active
                   ? "Please enable the cohort before recalculating reports."
                   : ""
               }
               placement="bottom"
             >
               <span>
                 <RecalculateCohortLabel
                   disabled={!cohortWithId?.active}
                   onClick={() => {
                     if (cohortWithId?.active) {
                       handleRecalculateReports();
                     }
                   }}
                 >
                   Recalculate reports
                 </RecalculateCohortLabel>
               </span>
             </StyledTooltipWrapper>
           )}

          {(loading && cohortWithId?.active) && <LoadingLabel>Refreshing...</LoadingLabel>}
       
        </RecalculateContainer>
         <Description style={{marginLeft: '13px'}}>Cohort Title:</Description>
        <CohortTitle>{selectedCohortId?.title || '-'}</CohortTitle>
      </div>
        <HeaderContainer>
        <Button
                                classes={{ label: classes.label, root: classes.editCohort }}
                                onClick={() => {
                                    if(!loading){
                                        if((permission && updatePermission) || !permission){
                                            history.push(
                        "/auth/radAdmin/followUp/reports/cohorts/create",
                        { data: cohortWithId }
                      );
                                          }else{
                                            dispatch(
                                              showAlert('danger', 'Error', `You don't have permission to update cohort`)
                                            );
                                          }
                                    }
                                }}
                                style={{cursor:loading?'not-allowed': 'pointer'}}
                            >
                            Edit Cohort
                            </Button>
        <SearchFieldContainer>
          <SearchField
            placeholder="Search by Accession Number"
            value={titleForSearch}
            onChangeHandle={(e) => {
              setTitleForSearch(e.target.value);
              history.push({
                search: `?accession_number=${e.target.value}`,
              });
            }}
            onReset={() => {
              if (titleForSearch) {
                dispatch(getReportCohortWithId(1, selectedCohortId?.id, ""));
                setPage(1);
                setTitleForSearch("");
                history.push({
                  search: `?accession_number=`,
                });
              }
            }}
            onSearchEnter={() => {
              setPage(1);
              if (selectedCohortId?.id) {
                dispatch(
                  getReportCohortWithId(1, selectedCohortId?.id, titleForSearch)
                );
              }
            }}
            styles={{
              marginRight: 0,
              marginBottom: 0,
              width: "318px",
              position: "relative",
            }}
            placeholderStyles={{
              color: "#828282",
              fontWeight: 400,
              fontSize: "16px",
              fontFamily: "Open Sans",
              marginLeft: "32px",
            }}
            inputStyles={{
              background: "#FFFFFF",
              border: "1px solid #D2D3D7",
              textAlign: "left",
              paddingLeft: "20px",
              height: "38px",
            }}
            searchIconStyles={{
              marginLeft: "12px",
            }}
            clearIconStyle={{
              right: 20,
              marginLeft: 0,
            }}
            SearchIconCustom={<SearchIconCustom />}
          />
        </SearchFieldContainer>

        <div>
          <Button
            classes={{ label: classes.label, root: classes.campaignButton }}
            onClick={createCohortHandler}
          >
            {selectedIds?.length > 0
              ? "Export Selected Reports"
              : "Export Reports"}
          </Button>
        </div>
        <ExportCohortModal
          showModal={showCohortModal}
          closeModal={() => setShowCohortModal(false)}
        />
      </HeaderContainer>
      </div>


<div style={{ display: 'flex', marginTop: '30px', gap: '50px' }}>
  {cohortWithId?.computed_status_criteria ? (
    <div>
      <HeadingWrapper style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
        <div>
          <Description>Report Tracking:</Description>
        </div>
        <div style={{ display: 'flex', gap: '15px' }}>
          <div>
            <SelectDropdownTitle>
              Computed Status
              <div style={{ fontWeight: 400, color: 'black' }}>
                {cohortWithId?.computed_status_criteria?.computed_status_filter
                  ?.map(itm =>
                    itm
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, char => char.toUpperCase())
                  )
                  ?.join(', ') ?? '-'}
              </div>
            </SelectDropdownTitle>
          </div>

          <div>
            <SelectDropdownTitle>
              Days
              <div style={{ fontWeight: 400, color: 'black' }}>
                {cohortWithId?.computed_status_criteria?.days ?? '-'}
              </div>
            </SelectDropdownTitle>
          </div>

          <div>
            <SelectDropdownTitle>
              Modality Mappings
              <ol style={{ fontWeight: 400, color: 'black', margin: 0, paddingLeft: 13 }}>
                {cohortWithId?.computed_status_criteria?.modality_mappings?.map((itm, index) => (
                  <li key={index} style={{ marginBottom: '4px', whiteSpace: 'nowrap' }}>
                    Initial Modality: {itm.report2_modality}, Subsequent Modality: {itm.subsequent_modality}
                  </li>
                ))}
              </ol>
            </SelectDropdownTitle>
          </div>

          <div>
            <SelectDropdownTitle>
              Exam Code Mappings
              <ol style={{ fontWeight: 400, color: 'black', margin: 0, paddingLeft: 13 }}>
                {cohortWithId?.computed_status_criteria?.exam_code_mappings?.map((itm, index) => (
                  <li key={index} style={{ marginBottom: '4px', whiteSpace: 'nowrap' }}>
                    Initial Exam Code: {itm.report2_exam_code}, Subsequent Exam Code: {itm.subsequent_exam_code}
                  </li>
                ))}
              </ol>
            </SelectDropdownTitle>
          </div>
        </div>
      </HeadingWrapper>

      <div>
        <HeadingWrapper style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', marginTop: '15px' }}>
          <Description>Cohort Description:</Description>
          <DescriptionValue>
            <DescriptionChipGroups parents={parents} operators={operators} whiteSpace="wrap" />
          </DescriptionValue>
        </HeadingWrapper>
      </div>
    </div>
  )
   :
  <div>
        <HeadingWrapper style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', marginTop: '15px' }}>

          <Description>Cohort Description:</Description>
          <DescriptionValue>
            <DescriptionChipGroups parents={parents} operators={operators} whiteSpace="wrap" />
          </DescriptionValue>
        </HeadingWrapper>
 </div>
}
</div>



<Card>
<div style={{paddingLeft: '26px', paddingTop: '26px'}}>
            <div>
              <FilterContainer>
                <SelectDropdownTitle>timeframe</SelectDropdownTitle>
                <Filter
                  options={options}
                  filterValue={filterValue}
                  setFilterValue={setFilterValue}
                  startDate={startDate}
                  setStartDate={setStartDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                  setSelectedDate={setSelectedDate}
                  type="radio"
                  selectContainerStyles={{ textAlign: "left" }}
                  popperPlacement={'bottom-start'}
                />
              </FilterContainer>
            </div>
      <div style={{height: '400px', margin: '30px, 0px'}}>
      { (chartLoading || loading) ? (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
    <Spinner animation="border" role="status" size="sm" />
  </div>) : computedStatusData?.length == 0 ? (
  <StyledEmptyContainer>
    <span>no data available for this report</span>
  </StyledEmptyContainer>
) : cohortWithId?.total_reports > 0 && computedStatusData?.length > 0 ? (

  <ResponsiveContainer width="100%" height="80%">
  <LineChart
    data={computedStatusData}
    width={730}
    height={250}
    margin={{
      top: 30,
      right: 30,
      left: 20,
      bottom: 5,
    }}
  >
    <CartesianGrid strokeDasharray="3 3" />
    <XAxis 
      dataKey="created"
    />
    <YAxis />
    <Tooltip
      formatter={(value, name) => {
        const formattedName = name.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
        return [value, formattedName];
      }}
      contentStyle={{ textAlign: 'left', padding: '4px 8px' }}
      itemStyle={{ marginBottom: '1px' }}
      wrapperStyle={{ textAlign: 'left' }}
    />
    <Legend />
    {dynamicStatuses?.map((status) => (
      <Line
        key={status}
        type="monotone"
        dataKey={status}
        stroke={computedStatusColors[status]}
        strokeWidth={2}
        dot={{ fill: computedStatusColors[status], r: 4 }}
        activeDot={{ r: 6 }}
        name={status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
      />
    ))}
  </LineChart>
</ResponsiveContainer>
) : null}
      </div>
      </div>
</Card>
     
      <Card>
        <>
          {cohortReportListWithId?.totalItems === null &&
            !cohortReportListWithId?.isLoading ? (
            <StyledEmptyContainer>
              <span>Type search or select filters to fetch results</span>
            </StyledEmptyContainer>
          ) : (
            <>
              <Table
                rows={cohortReportListWithId?.data}
                initialPageNumber={cohortReportListWithId?.pageNumber}
                columns={[
                  {
                    key: "",
                    name: "",
                    displayCell: (cellValue, rowData) => (
                      <DoubleDataCell
                        mainInfo={"checkbox"}
                        checkboxHandler={() => checkboxHandler(rowData)}
                      // checked={selectedIds?.includes(rowData?.id)}
                      />
                    ),
                  },
                ].concat(SearchReportsColumns)}
                checkboxHandler={checkboxHandler}
                totalItems={cohortReportListWithId?.totalItems}
                isLoadingRows={cohortReportListWithId?.isLoading && page < 2}
                noDataRender={() => (
                  <EmptyState
                    title={"No Results"}
                    img={() => <EmptyStateImg />}
                    imageContainerStyles={{ width: "73px", height: "81px" }}
                  >
                    Sorry, there are no results
                  </EmptyState>
                )}
                shouldGetRowActions={false}
              />
              {cohortReportListWithId?.data &&
                cohortReportListWithId?.data.length !== 0 && (
                  <LoadMoreButton
                    title="Load more reports"
                    handleClick={onLoadMore}
                    isDisabled={
                      cohortReportListWithId?.totalItems ===
                      cohortReportListWithId?.data?.length
                    }
                    isLoading={cohortReportListWithId?.isLoading}
                    style={{
                      backgroundColor: "#0c2945",
                      fontWeight: 600,
                    }}
                  />
                )}
            </>
          )}
        </>
      </Card>

    </Box>
  );
};

export default ViewReports;
